import React, { Component } from 'react';
import PropTypes from 'prop-types';
import styles from './data-card-row.module.scss';
import ChartArea from './chart-area';
import Select from 'react-select';
import * as selectors from '../../reducers';
import { connect } from 'react-redux';
import { getCategoryUnit, camelize } from '../../helpers/formatters';
import definitionMapper from '../../helpers/definition-mapper';
import throttle from 'lodash/throttle';

class DataCardRow extends Component {
  constructor(props) {
    super();
    this.state = {
      selectedSubCategory: props.data.subCategories
        ? props.data.subCategories[0]
        : null,
      visible: false,
    };
    this.handleSubCategoryChange = this.handleSubCategoryChange.bind(this);
    this.handleScroll = throttle(this.handleScroll.bind(this), 100);
    window.addEventListener('scroll', this.handleScroll);
  }

  componentDidMount() {
    this.handleScroll();
  }

  componentWillUnmount() {
    this.removeListener();
  }

  removeListener() {
    window.removeEventListener('scroll', this.handleScroll);
  }

  handleScroll() {
    if (this.props.revealed && !this.state.visible && this.isInView()) {
      this.setState({
        visible: true,
      });
      this.removeListener();
    }
  }

  isInView() {
    const el = this.containerElement;
    const rect = el.getBoundingClientRect();
    const elemTop = rect.top;
    const elemBottom = rect.bottom;
    return elemTop < window.innerHeight * 0.85 && elemBottom >= 0;
  }

  handleSubCategoryChange(selectedSubCategory) {
    this.setState({ selectedSubCategory });
  }

  renderSelect(row) {
    const { selectedSubCategory } = this.state;
    const { color, isCardExpanded } = this.props;
    if (!row.subCategories) return null;
    const options = row.subCategories.filter(x => x.value !== '_trend');
    if (options.length < 2) return null;
    return (
      <div className={styles.selectWrapper} onClick={e => e.stopPropagation()}>
        <Select
          tabIndex={isCardExpanded ? '0' : '-1'}
          className={`subCategoryDropdown ${color}`}
          name="subCategoryDropdown"
          value={selectedSubCategory}
          onChange={this.handleSubCategoryChange}
          options={options}
          clearable={false}
        />
      </div>
    );
  }

  renderChartsArea() {
    const { data, color, cardTitle } = this.props;
    const { selectedSubCategory, visible } = this.state;

    const title = data.title === 'Total' ? cardTitle : data.title;
    const chartData = selectedSubCategory
      ? data.data[selectedSubCategory.value]
      : data.data;

    const unit = getCategoryUnit(data.key);
    return (
      <div className={styles.dataCardRowRight}>
        <ChartArea
          data={chartData}
          title={title}
          color={color}
          unit={unit}
          visible={visible}
          trend={data.data._trend && data.data._trend[0].value}
        />
      </div>
    );
  }

  render() {
    const { data, cardTitle } = this.props;
    const { visible } = this.state;
    if (data.title === 'Total') {
      data.key = camelize(cardTitle);
    }

    return (
      <div
        className={styles.dataCardRow}
        ref={r => (this.containerElement = r)}
        data-visible={visible}
      >
        <div className={styles.dataCardRowLeft}>
          {data.title !== 'Total' ? (
            <div className={styles.dataCardRowTitle}>{data.title}</div>
          ) : null}
          <div>{definitionMapper[data.key]}</div>
          {this.renderSelect(data)}
        </div>

        {this.renderChartsArea()}
      </div>
    );
  }
}

const mapStateToProps = state => ({
  comparedCouncil: selectors.getComparedCouncil(state),
});

DataCardRow.propTypes = {
  comparedCouncil: PropTypes.object,
  data: PropTypes.object.isRequired,
  color: PropTypes.string.isRequired,
  cardTitle: PropTypes.string.isRequired,
  isCardExpanded: PropTypes.bool.isRequired,
};

export default connect(
  mapStateToProps,
  null
)(DataCardRow);



// WEBPACK FOOTER //
// ./src/components/data-card-row/data-card-row.js